import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { contentGenerationContextToolSchema } from "../../content-generation-context-tool/content-generation-context-tool-definition";
import { marketingAgentPromptGoalSchema } from "../marketing-agent-prompt-goal/marketing-agent-prompt-goal-definition";
import { marketingAgentPromptMethodSchema } from "../marketing-agent-prompt-method/marketing-agent-prompt-method-definition";

// Our only supported agent is the content generator agent. If we add more agents,
// we need to add it to this enum.
export enum MarketingAgent {
  CONTENT_GENERATOR_AGENT = "contentGeneratorAgent",
}

export enum PromptCategory {
  STRATEGY = "strategy",
  TRIGGER = "trigger",
}

const marketingAgentPromptSchema_ = z.object({
  _id: zExt.objectId(),
  version: z.number(),
  agent: createEnum(MarketingAgent),
  promptCategory: createEnum(PromptCategory),
  // This would be considered the version. If I have a prompt and I want to update it,
  // I should use the same promptType to indicate it's the same prompt
  promptType: z.string(),
  // For STRATEGY prompts: goalId and methodId are used instead of prompt
  // For TRIGGER prompts: prompt field is still used
  marketingAgentPromptGoalId: zExt.objectId().optional(),
  marketingAgentPromptMethodId: zExt.objectId().optional(),
  prompt: z.string().optional(),
  examples: z.string(),
  // These are human readable labels and descriptions used to display the prompt in the UI
  displayLabel: z.string(),
  displayDescription: z.string().optional(),
  description: z.string().optional(),
  contextTools: z.array(contentGenerationContextToolSchema),
  createdAt: z.date(),
  updatedAt: z.date(),
  // Disable flag for disabled prompts; we'll still use old prompts for analytics
  disabledAt: z.date().nullish(),
});

export const marketingAgentPromptSchema: z.ZodType<MarketingAgentPrompt> =
  marketingAgentPromptSchema_;
export interface MarketingAgentPrompt
  extends z.infer<typeof marketingAgentPromptSchema_> {}

// Populated version with goal and method documents
const marketingAgentPromptPopulatedSchema_ = marketingAgentPromptSchema_.extend(
  {
    marketingAgentPromptGoal: marketingAgentPromptGoalSchema.optional(),
    marketingAgentPromptMethod: marketingAgentPromptMethodSchema.optional(),
  },
);

export const marketingAgentPromptPopulatedSchema: z.ZodType<MarketingAgentPromptPopulated> =
  marketingAgentPromptPopulatedSchema_;
export interface MarketingAgentPromptPopulated
  extends z.infer<typeof marketingAgentPromptPopulatedSchema_> {}
